module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "140px",
      "margin": "24px 24px 24px 24px",
      "display": "inline-block",
      "float": "left",
      "overflow": "hidden"
    }
  }), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 188px)",
      "height": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.versioncode : ''))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_appType')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config.data.appCategoryName))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.packagename : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_introl')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config.data.appDesc))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.captures ? _vm.captures.length > 0 : false),
      expression: "captures? captures.length > 0 : false"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_screenShot')) + " ")]), _vm._v(" "), _c('div', _vm._l((_vm.captures), function(item) {
    return _c('img', {
      staticClass: "gBorder",
      staticStyle: {
        "width": "180px",
        "height": "320px",
        "margin": "24px 0 24px 24px",
        "border-radius": "4px"
      },
      attrs: {
        "onerror": "this.src='/static/img/df-h.png'",
        "src": _vm.imgFullUrl(item)
      }
    })
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 2 && _vm.config.isHistory),
      expression: "config.type === 2 && config.isHistory"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_hisVer')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ulNew')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appCategoryName",
      "width": "",
      "label": _vm.$t('app_type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.dateFormat,
      "prop": "createTime",
      "width": "170",
      "label": _vm.$t('app_createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "90",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.config.data.isoperation === 0),
            expression: "config.data.isoperation === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteAppHis(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ab22200"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nonintelligent/bsiness/edit.vue
// module id = 1069
// module chunks = 0